import { NgClass } from '@angular/common';
import { Component, ChangeDetectionStrategy, input } from '@angular/core';

@Component({
    selector: 'app-hero',
    templateUrl: './hero.component.html',
    styleUrl: './hero.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass],
})
export class HeroComponent {
    public imagePath = input.required<string>();
    public imageAlt = input.required<string>();
    public imageAlign = input<'center' | 'top' | 'bottom'>('center');
    public headline = input<string>('');
    public textInImage = input<string>();
}
